import { CapacitorHttp } from "@capacitor/core";
import { OpenAPI } from "@/generated-api/core/OpenAPI";

let sharedRefreshPromise: Promise<string | null> | null = null;

class RefreshError extends Error {
  constructor(public readonly status: number) {
    super(`Refresh failed: ${status}`);
  }
}

const doRefresh = async (): Promise<{ access_token: string }> => {
  const response = await CapacitorHttp.request({
    method: "POST",
    url: `${OpenAPI.BASE}/api/auth/refresh`,
    headers: {
      ...(OpenAPI.HEADERS as Record<string, string> | undefined),
    },
  });
  if (response.status < 200 || response.status >= 300) {
    throw new RefreshError(response.status);
  }
  return response.data as { access_token: string };
};

export async function tryRefreshingTokenNative(
  setToken: (accessToken: string) => void,
  clearToken: () => void,
): Promise<string | null> {
  if (!sharedRefreshPromise) {
    sharedRefreshPromise = (async () => {
      try {
        const tokenData = await doRefresh();
        setToken(tokenData.access_token);
        return tokenData.access_token;
      } catch (err) {
        if (err instanceof RefreshError && err.status === 401) {
          clearToken();
          return null;
        }
        await new Promise((r) => setTimeout(r, 300));
        try {
          const retryData = await doRefresh();
          setToken(retryData.access_token);
          return retryData.access_token;
        } catch (finalErr) {
          clearToken();
          throw finalErr;
        }
      }
    })().finally(() => {
      sharedRefreshPromise = null;
    });
  }
  return sharedRefreshPromise;
}
